import type { GiftProductApiDto } from '__generated__/api/unauth/types.gen';

import { GiftListItem } from '@/app/_components/DonationTemp/GiftListItem';

import { SearchEmptyResults } from '../SearchEmptyResults';

export function GiftList({ items }: { items: GiftProductApiDto[] }) {
  if (items.length < 1) return <SearchEmptyResults />;

  return (
    <ul className="grid grid-cols-3 gap-x-16 gap-y-32 pb-40 mobile:grid-cols-2 mobile:gap-x-12 mobile:gap-y-24 mobile-tablet:px-20">
      {items.map((item) => (
        <li key={item.productNumber ?? item.productId}>
          <GiftListItem
            mainImageUrl={item.mainImageUrl}
            productName={item.productName}
            donationAmount={item.requiredDonationAmount}
            reviewRating={item.reviewRating}
            reviewCount={item.reviewCount}
            productNumber={item.productNumber}
          />
        </li>
      ))}
    </ul>
  );
}
